.tooltip {
  z-index: var(--z-tooltip);
  max-width: var(--size-popover);
  padding: var(--space-1) var(--space-2);
  border-radius: var(--radius-sm);
  background: var(--color-fg);
  box-shadow: var(--shadow-2);
  color: var(--color-canvas);
  font-size: var(--text-xs);
  line-height: var(--lh-xs);
}
